/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../connect/v2/common/sort';
import '../../common/sort_fields';
import '../../common/locale';
import '../../resources/product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "ListProductsRequest": {
                    "fields": {
                      "storeCode": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "sortOrder": {
                        "type": "squareup.connect.v2.common.SortOrder",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": "ASC"
                        }
                      },
                      "sortField": {
                        "type": "squareup.solidshop.v2.common.ProductSortField",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "CREATED_AT"
                        }
                      },
                      "limit": {
                        "type": "int32",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": 25
                        }
                      },
                      "cursor": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 6,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      }
                    }
                  },
                  "ListProductsResponse": {
                    "fields": {
                      "products": {
                        "type": "squareup.solidshop.v2.resources.Product",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE ListProductsRequest @ squareup/solidshop/v2/service/products/list_products.proto at 14:1
 */
export const ListProductsRequest = $root.lookupType('squareup.solidshop.v2.service.ListProductsRequest');
fixType(ListProductsRequest);
Builder.createAndAttachToType(ListProductsRequest);
/**
 * SOURCE ListProductsResponse @ squareup/solidshop/v2/service/products/list_products.proto at 34:1
 */
export const ListProductsResponse = $root.lookupType('squareup.solidshop.v2.service.ListProductsResponse');
fixType(ListProductsResponse);
Builder.createAndAttachToType(ListProductsResponse);
